import { Component, ElementRef, OnInit, Inject } from '@angular/core';
import { UmsService } from '../ums.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-print-msg-box',
  templateUrl: './print-msg-box.component.html',
  styleUrls: ['./print-msg-box.component.scss']
})
export class PrintMsgBoxComponent implements OnInit {

  constructor( private elRef: ElementRef,
    public umsService: UmsService,
    public dialogRef: MatDialogRef<PrintMsgBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    onClose(response: boolean) {
      this.dialogRef.close(response);
    }
  ngOnInit(): void {
    let the = localStorage.getItem('theme')
  }

  SelectData(value){
    if(value == "P"){
      this.dialogRef.close();
    }
    else if(value == "E"){
      let payload = {};
      
      this.umsService.centPaper(payload).subscribe((res) => {
        if (res.status) {
          
        }
      });
    }
  }

}
